'use client';

import { c as _c } from "react/compiler-runtime";
import { QueryClient, QueryClientProvider } from '@tanstack/react-query';
import dynamic from 'next/dynamic';
import { useState } from 'react';
const ReactQueryDevtools = dynamic(() => import('@tanstack/react-query-devtools').then(mod => mod.ReactQueryDevtools), {
  ssr: false,
  loading: () => null
});
interface QueryProviderProps {
  children: React.ReactNode;
}
export default function QueryProvider(t0) {
  const $ = _c(4);
  const {
    children
  } = t0;
  const [queryClient] = useState(_temp3);
  let t1;
  if ($[0] === Symbol.for("react.memo_cache_sentinel")) {
    t1 = process.env.NODE_ENV === "development" && <ReactQueryDevtools initialIsOpen={false} />;
    $[0] = t1;
  } else {
    t1 = $[0];
  }
  let t2;
  if ($[1] !== children || $[2] !== queryClient) {
    t2 = <QueryClientProvider client={queryClient}>{children}{t1}</QueryClientProvider>;
    $[1] = children;
    $[2] = queryClient;
    $[3] = t2;
  } else {
    t2 = $[3];
  }
  return t2;
}
function _temp3() {
  return new QueryClient({
    defaultOptions: {
      queries: {
        staleTime: 60000,
        retry: _temp,
        refetchOnWindowFocus: false
      },
      mutations: {
        retry: _temp2
      }
    }
  });
}
function _temp2(failureCount_0, error_0) {
  if (error_0?.response?.status >= 400 && error_0?.response?.status < 500) {
    return false;
  }
  return failureCount_0 < 2;
}
function _temp(failureCount, error) {
  if (error?.response?.status >= 400 && error?.response?.status < 500) {
    if (error?.response?.status === 408 || error?.response?.status === 429) {
      return failureCount < 2;
    }
    return false;
  }
  return failureCount < 3;
}